import { ISquare } from '../../types'

export const SquareConfig: ISquare = {
  width: 20,
  height: 20,
  border: '1px solid #ccc'
}
